module.exports = __webpack_public_path__ + "static/media/bg-boost-mobile.47ef0c28.svg";